module.exports = __webpack_public_path__ + "img/40-r.6a2370c6.png";